export default "__VITE_ASSET__Dydnkn2T__"